import { createFileRoute } from "@tanstack/react-router";

import { PatientSyncOngoingImportsPage } from "@/uiKit/pages/PatientSyncOngoingImportsPage.tsx";

export const Route = createFileRoute("/_practitioner/patient-sync/ongoing-imports")({
  component: PatientSyncOngoingImportsPage,
});
